module.exports = __webpack_public_path__ + "img/RatBNB.cd26c48a.png";